import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import CompanyPicker from '../../company/components/CompanyPicker'
import SubsidiaryPicker from '../../company/components/SubsidiaryPicker'
import {OPEN_TICKET_CMD_UPDATED, updateOpenTicketCmd} from '../actions'
import {OpenTicketCmd} from '../models'
import i18n from '../i18n'

const BILLING_TYPE = ['StandardAccount', 'PremiumAccount']

function getUserCompany(user) {
    switch(user.userType) {
        case 'executive':
        case 'patrimonyManager':
            return user.company
        case 'clientAccountManager':
            return !user.isPartOfHolding && user.company || undefined
        default:
            return undefined
    }
}

function getHolding(user) {
    if (user.isPartOfHolding) return user.company
    return null
}

class OpenTicketCompanyModal extends Component {
    static propTypes = {
        onSubmit: PropTypes.func
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, authenticated} = this.props

        const company = getUserCompany(authenticated)
        const holding = getHolding(authenticated)        
        
        dispatch(updateOpenTicketCmd({company, locationRef: {locationReferenceType: 'PatrimonyLocation'}}))

        const opened = !company
        this.setState({opened, holding})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.authenticated != this.props.authenticated) {
            const {dispatch, authenticated} = nextProps
            
            const company = getUserCompany(authenticated)
            const holding = getHolding(authenticated)
            
            dispatch(updateOpenTicketCmd({company}))

            this.setState({holding})
        }
        if (nextProps.cmd && nextProps.cmd != this.props.cmd) {
            if (nextProps.cmd.company != (this.props.cmd && this.props.cmd.company)) {
                const {cmd} = nextProps
                const {opened} = this.state

                const nextOpened = opened || !cmd.company
                this.setState({opened: nextOpened})
            }
        }
    }

    _close() {
        this.setState({opened: false})
        return true
    }

    _cancel(e) {
        const {onSubmit} = this.props

        this.setState({opened: false})
        onSubmit && onSubmit(e, 'Cancel')
    }

    render() {
        const {dispatch, form, cmd, authenticated, onSubmit, ...others} = this.props
        const {opened, holding} = this.state

        return (
            <Modal
                show={opened}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.pickCompany}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {holding && (
                        <SubsidiaryPicker
                            holding={holding}
                            {...form.company()}/>
                    )}
                    {!holding && (
                        <CompanyPicker
                            billingType={BILLING_TYPE}
                            includeSubsidiaries={true}
                            {...form.company()}/>
                    )}
                    <ButtonToolbar>
                        <Button
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.company.isValid()})}
                            onClick={() => (form.validate() || form.company.isValid()) && this._close() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </Button>
                        <Button
                            bsSize='large'
                            onClick={(e) => this._cancel(e)}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

OpenTicketCompanyModal = connectForm({
    target: 'cmd',
    schema: OpenTicketCmd.schema,
    action: OPEN_TICKET_CMD_UPDATED
})(OpenTicketCompanyModal)

OpenTicketCompanyModal = connect((state) => ({
    authenticated: state.user.authenticated,
    cmd: state.ticket.openTicketCmd
}))(OpenTicketCompanyModal)

export default OpenTicketCompanyModal


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketCompanyModal.js